"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const validators_1 = require("../../../validators");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let EmailTemplateVersionInput = class EmailTemplateVersionInput {
};
tslib_1.__decorate([
    type_graphql_1.Field(),
    class_validator_1.Validate(validators_1.IsSemVer),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionInput.prototype, "version", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateVersionInput.prototype, "emailTemplateId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionInput.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    class_validator_1.IsIn([
        'templateURL',
        'versionURL',
        'pastedHTML',
        'hostedFileURL',
        'oceanEditor',
        'emailEditor',
    ]),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionInput.prototype, "codePulledFrom", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    class_validator_1.ValidateIf(obj => obj.url !== '' && obj.url !== null),
    class_validator_1.IsUrl(),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionInput.prototype, "url", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateVersionInput.prototype, "releaseNotes", void 0);
EmailTemplateVersionInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], EmailTemplateVersionInput);
exports.EmailTemplateVersionInput = EmailTemplateVersionInput;
//# sourceMappingURL=EmailTemplateVersionInput.js.map